"use strict";

export default function routes($stateProvider) {
  "ngInject";

  $stateProvider.state("directDrMemberAuthors", {
    url: "/direct-dr-member-authors",
    template: require("./direct-dr-member-authors.html"),
    controller: "DirectDrMemberAuthorsController",
    controllerAs: "directDrMemberAuthorsCtrl",
  });
}



// WEBPACK FOOTER //
// ./client/app/direct-dr-member-authors/direct-dr-member-authors.routes.js